define('wavideos', ['jquery'], function ($) {

  var wavideos = {
    media: [],

    init: function init() {
      this.videoElements = $("[data-video]:not([data-init]),.youtube-video");
      this.setVideoIds();
    },
    setVideoIds: function setVideoIds() {
      var _this = this;

      if (this.videoElements.length === 0) return;

      this.videoElements.each(function (i, el) {
        var self = $(el);
        var videoID = self.hasClass('youtube-video') ? self.data('youtube-id') : self.data('video');
        _this.testUrlForMedia(videoID, i);
      });

      if (this.media.length === 0) return;

      this.setLazyVideos();
    },
    testUrlForMedia: function testUrlForMedia(url, i) {

      if (url.match('vimeo\.com')) {
        var m = url.match(/^.+vimeo.com\/(.*\/)?([^#\?]*)/);
        var id = m ? m[2] || m[1] : null;

        wavideos.media.push({
          "provider": "vimeo",
          "id": id
        });
      } else {
        var _id = void 0;
        url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
          _id = url[2].split(/[^0-9a-z_\-]/i);
          _id = _id[0];
        } else {
          _id = url;
        }

        _id = _id instanceof Array ? _id[0] : _id;

        this.media.push({
          "provider": "youtube",
          "id": _id,
          "thumb": 'https://img.youtube.com/vi/' + _id + '/hqdefault.jpg'
        });
      }
    },
    setLazyVideos: function setLazyVideos() {
      var _this2 = this;

      $.each(this.media, function (i, val) {
        if (_this2.media[i].provider === "vimeo") {
          $.getJSON('https://www.vimeo.com/api/v2/video/' + _this2.media[i].id + '.json?callback=?', {
            format: "json",
            async: false
          }, function (data) {
            var videoWrapper = wavideos.videoElements.eq(i);
            if (videoWrapper.children().length > 0) return;
            videoWrapper.append('\n                <div class="wavideo" data-provider="' + wavideos.media[i].provider + '" data-videoid="' + wavideos.media[i].id + '" style="background-image:url(' + data[0].thumbnail_large + ')">\n                  <div class="play-button"></div>\n                </div>\n                ');

            wavideos.bindClickEvent();
          });
        } else {
          var videoWrapper = _this2.videoElements.eq(i);
          if (videoWrapper.children().length > 0) return;
          videoWrapper.append('\n              <div class="wavideo" data-provider="' + _this2.media[i].provider + '" data-videoid="' + _this2.media[i].id + '" style="background-image:url(' + _this2.media[i].thumb + ');">\n                <div class="play-button"></div>\n              </div>\n            ');
          _this2.bindClickEvent();
        }
      });
    },
    bindClickEvent: function bindClickEvent() {
      $('.wavideo').unbind('click').on('click', function (e) {
        e.preventDefault();
        var self = $(e.currentTarget);
        var provider = self.data('provider');
        var videoid = self.data('videoid');
        var iframe = document.createElement("iframe");
        var src = void 0;

        if (provider == 'vimeo') {
          src = 'https://player.vimeo.com/video/' + videoid + '?autoplay=1&loop=1&autopause=0';
        } else {
          src = 'https://www.youtube.com/embed/' + videoid + '?rel=0&showinfo=0&autoplay=1';
        }

        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("src", src);

        self.html('').append(iframe);
      });
    }
  };

  window.wavideos = wavideos;
  return wavideos;
});

